export class ChildBase{
    id:number;
    name:string;
    familyId:number;
  }